import { fetchExtensionLocationSuggestions, LocationSuggestionsResult } from 'lib/extensionMessaging';

export const LINKEDIN_LOCATION_TYPEAHEAD_MESSAGE = 'harbor-linkedin-location-typeahead';

export type LinkedInLocationSuggestionsResult = LocationSuggestionsResult;

export function fetchLinkedInLocationSuggestions(
  query: string,
  isRemote: boolean,
): Promise<LinkedInLocationSuggestionsResult> {
  return fetchExtensionLocationSuggestions(LINKEDIN_LOCATION_TYPEAHEAD_MESSAGE, { query, isRemote });
}
